import { action, computed, observable } from 'mobx';
import {
    IAutomationStepActionFileBase,
    TAutomationStepBlockErrorMessageKeys
} from '../../../types/automation.types';
import { AutomationStepActionEmailBase } from './automation-step-action-email-base';
import { IFileTemplate } from '~/types/model.types';

export abstract class AutomationStepActionFileBase
    extends AutomationStepActionEmailBase
    implements IAutomationStepActionFileBase
{
    @observable file_template_id: string;

    @computed
    get isValid() {
        return !!this.email_template_id && !!this.file_template_id;
    }

    get errorMessageKey(): TAutomationStepBlockErrorMessageKeys {
        return 'missing_template';
    }

    abstract get fileTemplate(): IFileTemplate;

    @computed
    get title(): string {
        return this.fileTemplate?.title;
    }

    @action
    selectFileTemplate(templateId: string) {
        this.file_template_id = templateId;
    }
}
